"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formWrapper = _interopRequireDefault(require("../../formWrapper.js"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _helpers = require("./helpers.js");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _Filter = _interopRequireDefault(require("./Filter"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _Preview = _interopRequireDefault(require("./Preview"));
var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));
var _QueryView = _interopRequireDefault(require("./QueryView"));
var _SettingsForm = _interopRequireDefault(require("./SettingsForm"));
var _AddColumnsForm = _interopRequireDefault(require("./AddColumnsForm"));
var _EditColumnForm = _interopRequireDefault(require("./EditColumnForm"));
var _arrowResize = _interopRequireDefault(require("cccisd-icons/svg/arrow-resize4"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross4"));
var _plus = _interopRequireDefault(require("cccisd-icons/svg/plus2"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _reducer = _interopRequireWildcard(require("./reducer.js"));
var _reactRedux = require("react-redux");
var _prettify = require("./prettify.js");
var _useTable3 = _interopRequireDefault(require("./useTable.js"));
var _renders = _interopRequireDefault(require("./renders"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable no-shadow */
var Table = function Table(props) {
  var fields = props.fields,
    settings = props.settings;
  var columns = settings.columns,
    level = settings.level,
    rows = settings.rows,
    projectId = settings.projectId,
    variables = settings.variables,
    columnRenderParams = settings.columnRenderParams;
  var loading = (0, _reactRedux.useSelector)(function (state) {
    return state.tableEditor.loading;
  });
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTable = (0, _useTable3["default"])(settings),
    _useTable2 = _slicedToArray(_useTable, 2),
    query = _useTable2[0],
    debouncedSettings = _useTable2[1];
  (0, _react.useEffect)(function () {
    dispatch((0, _reducer.loadColumnTree)(level, rows, projectId));
  }, [level, rows]);
  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  var addColumnsAfter = function addColumnsAfter(index, values, arrayHelpers) {
    if (values.columns) {
      var newColumns = Object.values(values.columns).sort(function (a, b) {
        return a.sort - b.sort;
      });
      var nextId = (0, _helpers.generateNewId)(settings.columns);
      var _iterator = _createForOfIteratorHelper(newColumns),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var column = _step.value;
          var _query = column.query || column.id;
          arrayHelpers.insert(1 + index++, {
            id: nextId++,
            name: (0, _helpers.getPathFromQuery)(_query),
            query: _query,
            label: column.label,
            type: column.type,
            sort: true,
            filter: true,
            alignment: ['number', 'boolean'].includes(column.type) ? 'center' : 'left',
            render: column.type === 'boolean' ? 'checkmark' : ''
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else if (values.isAction) {
      var id = (0, _helpers.generateNewId)(settings.columns);
      arrayHelpers.insert(index + 1, _objectSpread({
        id: id,
        name: "action_".concat(id),
        label: values.label,
        alignment: 'left'
      }, values));
    } else {
      arrayHelpers.insert(index + 1, {
        id: (0, _helpers.generateNewId)(settings.columns),
        name: (0, _helpers.getPathFromQuery)(values.query),
        query: (0, _prettify.prettifyQuery)(values.query),
        label: values.label,
        type: values.type,
        sort: false,
        filter: false,
        alignment: ['number', 'boolean'].includes(values.type) ? 'center' : 'left',
        render: values.type === 'boolean' ? 'checkmark' : ''
      });
    }
  };
  var updateColumn = function updateColumn(_ref) {
    var values = _ref.values,
      prevValues = _ref.prevValues,
      arrayHelpers = _ref.arrayHelpers,
      index = _ref.index;
    if (values.render && values.renderSettings) {
      var currentRender = _renders["default"].find(function (item) {
        return item.handle === values.render;
      });
      if (currentRender.prepareValues) {
        values.renderSettings = currentRender.prepareValues(values.renderSettings);
      }
    }
    arrayHelpers.replace(index, _objectSpread(_objectSpread(_objectSpread({}, prevValues), values), values.isAction ? {} : {
      name: (0, _helpers.getPathFromQuery)(values.query),
      query: (0, _prettify.prettifyQuery)(values.query)
    }));
  };
  var updateTableSettings = function updateTableSettings(values) {
    for (var _i = 0, _Object$entries = Object.entries(values); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      if (key === 'perPage') {
        value = Number(value);
      }
      if (key === 'extraQuery' && value) {
        value = (0, _prettify.prettifyQuery)(value);
      }
      fields[key].onChange(value);
    }
  };
  var updateFilter = function updateFilter(values) {
    fields.filter.onChange(values);
  };
  var filterNumber = function () {
    if (!settings.filter || !settings.filter.conditions) {
      return 0;
    }
    return settings.filter.conditions.length;
  }();
  var togglePlaceholder = /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      visibility: 'hidden',
      height: 0,
      overflow: 'hidden'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], null));
  var buttonsPlaceholder = /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      visibility: 'hidden',
      height: 0,
      overflow: 'hidden'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].buttons
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-success btn-xs",
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null)), ' ', /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-success btn-xs",
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))));
  var usedColumns = new Set(columns.map(function (column) {
    return column.name;
  }));
  var graphqlVariables = {};
  if (variables && variables.length > 0) {
    graphqlVariables = variables.filter(function (variable) {
      return variable.previewValue;
    }).reduce(function (obj, variable) {
      // eslint-disable-next-line no-eval
      eval("obj[variable.name] = ".concat(variable.previewValue, ";"));
      return obj;
    }, {});
  }
  var columnRenderParamsForPreview = {};
  if (columnRenderParams) {
    columnRenderParams.forEach(function (prop) {
      // eslint-disable-next-line no-eval
      eval("columnRenderParamsForPreview[prop.name] = ".concat(prop.previewValue, ";"));
    });
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-primary"
    }, "Table Settings"),
    title: "Table Settings"
  }, /*#__PURE__*/_react["default"].createElement(_SettingsForm["default"], {
    settings: settings,
    onSubmit: updateTableSettings
  })), ' ', /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-primary"
    }, "Filters - ".concat(filterNumber)),
    size: "large",
    title: "Filters"
  }, /*#__PURE__*/_react["default"].createElement(_Filter["default"], {
    initialValues: settings.filter,
    updateFilter: updateFilter
  })), ' ', /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-primary"
    }, "Show query"),
    size: "large",
    title: "GraphQL Query"
  }, /*#__PURE__*/_react["default"].createElement(_QueryView["default"], {
    settings: settings
  }))), /*#__PURE__*/_react["default"].createElement("h3", null, "Columns - ", columns.length), columns.length === 0 ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: {
      columns: columns
    },
    onValidChange: function onValidChange(values) {
      return fields.columns.onChange(values.columns);
    },
    isInitialValid: true,
    render: function render() {
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
        name: "columns",
        render: function render(arrayHelpers) {
          return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
            trigger: /*#__PURE__*/_react["default"].createElement("button", {
              type: "button",
              className: "btn btn-primary"
            }, "Add columns"),
            title: "Add columns",
            render: function render(_ref2) {
              var closeModal = _ref2.closeModal;
              return /*#__PURE__*/_react["default"].createElement(_AddColumnsForm["default"], {
                tableSettings: settings,
                onSubmit: function onSubmit(values) {
                  addColumnsAfter(-1, values, arrayHelpers);
                  closeModal();
                }
              });
            }
          });
        }
      }));
    }
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].columnsHeader
  }, /*#__PURE__*/_react["default"].createElement("div", null, buttonsPlaceholder), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '16em'
    }
  }, "Label"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '16em'
    }
  }, "Tooltip"), /*#__PURE__*/_react["default"].createElement("div", null, togglePlaceholder, "Filter"), /*#__PURE__*/_react["default"].createElement("div", null, togglePlaceholder, "Sort")), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: {
      columns: columns
    },
    onValidChange: function onValidChange(values) {
      return fields.columns.onChange(values.columns);
    },
    isInitialValid: true,
    render: function render(_ref3) {
      var values = _ref3.values;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
        name: "columns",
        render: function render(arrayHelpers) {
          return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
            onDragEnd: function onDragEnd(_ref4) {
              var destination = _ref4.destination,
                source = _ref4.source;
              arrayHelpers.move(source.index, destination.index);
            }
          }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
            droppableId: "droppable"
          }, function (provided, snapshot) {
            return /*#__PURE__*/_react["default"].createElement("div", _extends({
              ref: provided.innerRef,
              className: _style["default"].columns
            }, provided.droppableProps), values.columns.map(function (item, index) {
              return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
                key: item.id,
                draggableId: "".concat(item.id),
                index: index
              }, function (provided1, snapshot1) {
                return /*#__PURE__*/_react["default"].createElement("div", _extends({
                  ref: provided1.innerRef
                }, provided1.draggableProps, {
                  className: _style["default"].column
                }), /*#__PURE__*/_react["default"].createElement("div", _extends({
                  className: (0, _classnames2["default"])(_style["default"].dragHandle, _defineProperty({}, _style["default"].disabled, false))
                }, provided1.dragHandleProps), /*#__PURE__*/_react["default"].createElement(_arrowResize["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
                  className: _style["default"].buttons
                }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
                  title: "Edit Column",
                  size: "large",
                  trigger: /*#__PURE__*/_react["default"].createElement("button", {
                    className: "btn btn-success btn-xs",
                    type: "button"
                  }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))
                }, /*#__PURE__*/_react["default"].createElement(_EditColumnForm["default"], {
                  onSubmit: function onSubmit(values) {
                    updateColumn({
                      values: values,
                      prevValues: item,
                      arrayHelpers: arrayHelpers,
                      index: index
                    });
                  },
                  settings: settings.columns[index],
                  tableSettings: settings
                })), ' ', /*#__PURE__*/_react["default"].createElement("button", {
                  className: "btn btn-danger btn-xs",
                  type: "button",
                  onClick: function onClick() {
                    return arrayHelpers.remove(index);
                  }
                }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null))), !snapshot1.isDragging && !snapshot.isDraggingOver && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
                  trigger: /*#__PURE__*/_react["default"].createElement("div", {
                    className: 'btn btn-secondary ' + _style["default"].addColumnAfter
                  }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null)),
                  title: "Add columns",
                  render: function render(_ref5) {
                    var closeModal = _ref5.closeModal;
                    return /*#__PURE__*/_react["default"].createElement(_AddColumnsForm["default"], {
                      tableSettings: settings,
                      usedColumns: usedColumns,
                      onSubmit: function onSubmit(values) {
                        addColumnsAfter(index, values, arrayHelpers);
                        closeModal();
                      }
                    });
                  }
                }), !snapshot1.isDragging && !snapshot.isDraggingOver && index === 0 && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
                  trigger: /*#__PURE__*/_react["default"].createElement("div", {
                    className: 'btn btn-secondary ' + _style["default"].addColumnBefore
                  }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null)),
                  title: "Add columns",
                  render: function render(_ref6) {
                    var closeModal = _ref6.closeModal;
                    return /*#__PURE__*/_react["default"].createElement(_AddColumnsForm["default"], {
                      tableSettings: settings,
                      usedColumns: usedColumns,
                      onSubmit: function onSubmit(values) {
                        addColumnsAfter(index - 1, values, arrayHelpers);
                        closeModal();
                      }
                    });
                  }
                }), /*#__PURE__*/_react["default"].createElement("div", {
                  className: _style["default"].cell,
                  style: {
                    width: '16em'
                  }
                }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
                  wrapperClassName: "",
                  name: "columns.".concat(index, ".label"),
                  component: _cccisdFormik.CccisdInput
                })), /*#__PURE__*/_react["default"].createElement("div", {
                  className: _style["default"].cell,
                  style: {
                    width: '16em'
                  }
                }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
                  wrapperClassName: "",
                  name: "columns.".concat(index, ".tooltip"),
                  component: _cccisdFormik.CccisdInput
                })), !item.isAction && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
                  className: _style["default"].cell
                }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
                  wrapperClassName: "",
                  name: "columns.".concat(index, ".filter"),
                  component: _cccisdFormik.CccisdToggle
                })), /*#__PURE__*/_react["default"].createElement("div", {
                  className: _style["default"].cell
                }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
                  wrapperClassName: "",
                  name: "columns.".concat(index, ".sort"),
                  component: _cccisdFormik.CccisdToggle
                }))));
              });
            }), provided.placeholder);
          }));
        }
      }));
    }
  })), /*#__PURE__*/_react["default"].createElement("h3", null, "Preview"), query && /*#__PURE__*/_react["default"].createElement(_ErrorBoundary["default"], {
    message: /*#__PURE__*/_react["default"].createElement("div", null, "Something went wrong with rendering preview.", /*#__PURE__*/_react["default"].createElement("br", null), "Loot at the console for details.")
  }, /*#__PURE__*/_react["default"].createElement(_Preview["default"], {
    query: query,
    settings: debouncedSettings,
    tableProps: {
      perPage: 5,
      graphqlVariables: graphqlVariables,
      columnRenderParams: columnRenderParamsForPreview
    }
  })));
};
var _default = exports["default"] = (0, _formWrapper["default"])({
  fields: ['title', 'notes', 'perPage', 'columns', 'filter', 'hasIdentifiable', 'showRowNumbers', 'showTotal', 'totalType', 'totalHeader', 'rowActions', 'extraQuery', 'variables', 'columnRenderParams', 'useTaskMaster']
})(Table);
var store = window.cccisd && window.cccisd.store;
if (store) {
  if (!store.getState().tableEditor) {
    store.injectReducer('tableEditor', _reducer["default"]);
  }
} else if (process.env.NODE_ENV !== 'test') {
  console.error('There is no redux store at window.cccisd');
}